import {
  Content,
  ContentSection,
  Question,
  WidgetType,
  getColumnById,
  getRoot,
  getSectionById,
  getWidgetById,
} from '@ael/core-api';

const getAllWidgetTypesFromContent = (content: Content) => {
  const root = getRoot(content);
  const sections = root.value.sections
    .map((sectionId) => getSectionById(content)(sectionId))
    .filter((section) => !!section);
  return sections
    .map((section: ContentSection) => {
      const columns = section.value.columns.map((columnId) => getColumnById(content)(columnId));
      return columns.map((column) => {
        if (!column.value.widget) {
          return undefined;
        }
        return getWidgetById(content)(column.value.widget).value.type;
      });
    })
    .flat();
};

export const hasGradableWidget = (question: Question) => {
  const widgetTypes = getAllWidgetTypesFromContent(question.content);
  return (
    widgetTypes.find(
      (type) =>
        type === WidgetType.question ||
        type === WidgetType.multipleResponseQuestion ||
        type === WidgetType.sortation ||
        type === WidgetType.hiddenArea
    ) !== undefined
  );
};
